import React from 'react';
import { hydrateRoot } from 'react-dom/client';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </React.StrictMode>
// );

hydrateRoot(
  document.getElementById("root"),
  <HelmetProvider>
    <BrowserRouter>
      <App
        initialData={window.__INITIAL_DATA__}
        initialSeo={window.__INITIAL_SEO__}
        initialSchema={window.__INITIAL_SCHEMA__}
        initialFaq={window.__INITIAL_FAQ__}
      />
    </BrowserRouter>
  </HelmetProvider>
);

reportWebVitals();
